import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { MeterReturnType, MeterSidebarSelectorType } from "../types";

interface MeterState {
  meterSidebarSelector: MeterSidebarSelectorType | null;
  comeFromMeterSidebarSelector: MeterSidebarSelectorType | null;
  tabSelector: string | null;
  dailyCutoffRecordId: string | null;
  setMeterSidebarSelector: (
    meterSidebarSelector: MeterSidebarSelectorType | null,
    comeFromMeterSidebarSelector?: MeterSidebarSelectorType | null
  ) => void;
  selectedMeter: MeterReturnType | null;
  setSelectedMeter: (meter: MeterReturnType | null) => void;
  setTabSelector: (tabSelector: string | null) => void;
  setDailyCutoffRecordId: (dailyCutoffRecordId: string | null) => void;
  selectedMetersForSharing: MeterReturnType[];
  toggleMeterForSharing: (meter: MeterReturnType) => void;
  clearSelectedMetersForSharing: () => void;
}

export const useMeterStore = create<MeterState>()(
  devtools(
    persist(
      (set) => ({
        meterSidebarSelector: null,
        comeFromMeterSidebarSelector: null,
        selectedMeter: null,
        tabSelector: null,
        dailyCutoffRecordId: null,
        selectedMetersForSharing: [],
        setMeterSidebarSelector: (
          meterSidebarSelector: MeterSidebarSelectorType | null,
          comeFromMeterSidebarSelector?: MeterSidebarSelectorType | null
        ) => {
          set(() => ({
            meterSidebarSelector: meterSidebarSelector,
            comeFromMeterSidebarSelector: comeFromMeterSidebarSelector || null,
          }));
        },
        setSelectedMeter: (selectedMeter: MeterReturnType | null) => {
          set(() => ({ selectedMeter: selectedMeter }));
        },
        setTabSelector: (tabSelector: string | null) => {
          set(() => ({ tabSelector: tabSelector }));
        },
        setDailyCutoffRecordId: (dailyCutoffRecordId: string | null) => {
          set(() => ({ dailyCutoffRecordId: dailyCutoffRecordId }));
        },
        toggleMeterForSharing: (meter: MeterReturnType) => {
          set((state) => {
            const isSelected = state.selectedMetersForSharing.some(
              (m) => m.id === meter.id
            );
            if (isSelected) {
              return {
                selectedMetersForSharing: state.selectedMetersForSharing.filter(
                  (m) => m.id !== meter.id
                ),
              };
            }
            return {
              selectedMetersForSharing: [...state.selectedMetersForSharing, meter],
            };
          });
        },
        clearSelectedMetersForSharing: () => {
          set(() => ({ selectedMetersForSharing: [] }));
        },
      }),
      {
        name: "meter-storage",
      }
    )
  )
);
